//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import TableComponent from '../../../components/TableComponent/TableComponent.vue'
import ReportMaterialsImageBtn from './ReportMaterialsImageBtn.vue'

export default {
  components: {
    TableComponent,
    ReportMaterialsImageBtn
  },
  props: {
    materialesAvailable: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data: function () {
    return {
      columnsMaterialesAvailable: [
        {
          name: 'toolName',
          label: 'Название',
          align: 'left',
          field: 'toolName',
          classes: 'class-bordered',
          sortable: true
        },
        {
          name: 'toolKey',
          label: 'ID номенклатурной позиции в 1С',
          align: 'left',
          field: 'toolKey',
          classes: 'class-bordered',
          sortable: true
        },
        {
          name: 'amount',
          label: 'Кол-во (доступное)',
          align: 'left',
          field: 'amount',
          classes: 'class-bordered',
          format: this.formatAmountMaterialesTable,
          sortable: true
        },
        {
          name: 'unit',
          label: 'Ед. изм.',
          align: 'left',
          field: 'unit',
          classes: 'class-bordered',
          sortable: true
        },
        {
          name: 'stockName',
          label: 'Склад',
          align: 'left',
          field: 'stockName',
          classes: 'class-bordered',
          format: (stockName, row) => this.formatStockNameMaterialesTable(stockName, row),
          sortable: true
        },
        {
          name: 'reserve',
          label: 'Резерв',
          align: 'left',
          field: 'reserve',
          classes: 'class-bordered',
          sortable: true
        },
        {
          name: 'block',
          label: 'Блокировка',
          align: 'left',
          field: 'block',
          classes: 'class-bordered',
          sortable: true
        }
      ]
    }
  },
  methods: {
    formatStockNameMaterialesTable: function (stockNames, row) {
      if (stockNames) {
        return stockNames.map(stock => stock + (row.isArchive && row.isArchive[stockNames.indexOf(stock)] ? ' (архивный)' : ''))
      } else {
        return 'Нет данных'
      }
    },
    formatAmountMaterialesTable: function (amount) {
      if (amount) {
        let sumAmount = ''
        for (let i = 0; i < amount.length; i++) {
          if (i === 0) {
            sumAmount = amount[i]
          } else {
            sumAmount += ', ' + amount[i]
          }
        }

        return sumAmount
      } else {
        return 'Нет данных'
      }
    }
  }
}

